import React from 'react'
import AppContext from './src/context/app'
import Head from 'react-helmet'

export default ({ element }) => (
  <AppContext>
    <Head>
      <title>Loading...</title>
    </Head>
    {element}
  </AppContext>
)
